module.exports = __webpack_public_path__ + "img/album07_15.de5f5174.jpg";